import { type BaseApiErrorResponse, HttpStatus } from '../types/api.types';
import BaseApiResponseError from './BaseApiResponseError';

export type InternalServerErrorArgs<TErrors> = Omit<
  BaseApiErrorResponse<TErrors>,
  'errors' | 'status'
>;
export default class InternalServerError<
  TErrors,
> extends BaseApiResponseError<TErrors> {
  constructor({ message }: InternalServerErrorArgs<TErrors>) {
    super({ errors: null, message, status: HttpStatus.InternalServerError });
  }
}
